// extracted by mini-css-extract-plugin
export default {"close":"CloseButton_close__5zbL3","img":"CloseButton_img__Cd+iO"};